export default function animate(stepRenderFn, duration, easing = easeInOutQuart) {
	const startX = 0;
	const endX = 1;
	const startTime = Date.now();
	
	function step() {
		stepRenderFn(easing(Date.now() - startTime, startX, endX - startX, duration));
		if (Date.now() - startTime >= duration)
			return stepRenderFn(1);
		requestAnimationFrame(step);
	}
	
	requestAnimationFrame(step)
}

// http://easings.net/#easeInOutQuart
//  t: current time
//  b: beginning value
//  c: change in value
//  d: duration
//
export function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

// http://easings.net/#easeInOutQuart
//  t: current time
//  b: beginning value
//  c: change in value
//  d: duration
//
export function easeLinear(t, b, c, d) {
	return c * (t / d) + b;
}